module.exports = "/_next/static/images/video_id_7122877999275494702-a7ca7f62c6e0de65999abf23fc60e876.jpg";